import type { SxProps, Theme } from '@mui/material/styles';
import { cockpitFieldLabelSx } from './cockpitFieldStyles';

/** The single visual contract shared by every CockpitSelect instance. */
export const cockpitSelectContainerSx: SxProps<Theme> = { minWidth: 0 };

export { cockpitFieldLabelSx as cockpitSelectLabelSx };

export const cockpitSelectRootSx: SxProps<Theme> = {
  height: '34px !important',
  minHeight: '34px !important',
  boxSizing: 'border-box',
  border: '1px solid var(--cockpit-border) !important',
  borderRadius: 'var(--cockpit-radius-pill) !important',
  boxShadow: 'none !important',
  overflow: 'hidden',
  '& .MuiSelect-select': {
    height: '34px !important',
    minHeight: '34px !important',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - 14px)',
    color: 'var(--cockpit-text-muted) !important'
  },
  '& .MuiOutlinedInput-notchedOutline': { display: 'none !important' },
  '&:hover:not(.Mui-disabled)': {
    borderColor: 'var(--cockpit-text-muted) !important',
    boxShadow: 'none !important'
  },
  '&.Mui-focused, &:focus-within, &:has(.MuiSelect-select[aria-expanded="true"])': {
    border: '2px solid var(--cockpit-accent) !important',
    boxShadow: 'none !important'
  }
};
